let constantNavList = {
  navList: [
    {
      name: '首页',
      path: '/home',
      control: [],
      isShow: true,
      children: []
    },
    {
      name: '销售管理',
      path: '/sale',
      control: [],
      isShow: false,
      children: [
        {
          name: '销售模块',
          path: '/sale/verify/info-list',
          control: ['/checkBill/list'],
          isShow: false
        },
        {
          name: '客户模块',
          path: '/sale/customer/user/list',
          control: ['/customers/saveOrUpdate'],
          isShow: false
        }
      ]
    },
    {
      name: '采购管理',
      path: '/purchase',
      control: [],
      isShow: false,
      children: [
        {
          name: '采购模块',
          path: '/purchase/apply/list',
          control: ['/shengou/buildShenGouBill', '/shengou/saveOrUpdate', '/caigou/saveOrUpdate'], //purchase
          isShow: false
        },
        {
          name: '供应商列表',
          path: '/purchase/supplier/user/list',
          control: ['/supplier/updateVue', '/supplier/saveVue'],
          isShow: false
        }
      ]
    },
    {
      name: '生产管理',
      path: '/production',
      control: [],
      isShow: false,
      children: [
        {
          name: '生产工单',
          path: '/new/renwu/list',
          control: ['/shengChanGongDan/list'],
          isShow: false
        },
        {
          name: '委外工单',
          path: '/new/weiwai/list',
          control: ['/weiWaiGongDan/list'],
          isShow: false
        },
        {
          name: '工序列表',
          path: '/new/gongxu/list',
          control: ['/gongxu/list3'],
          isShow: false
        },
        {
          name: '工艺列表',
          path: '/new/gongyi/list',
          control: ['/gongyi/list3'],
          isShow: false
        },
        {
          name: '生产班组',
          path: '/new/banzu/list',
          control: ['/banzu/list'],
          isShow: false
        },
        {
          name: '生产平面图',
          path: '/new/production/orgLayout',
          control: ['/banzu/list'],
          isShow: false
        },
        {
          name: '工艺流程图',
          path: '/new/production/processLayout',
          control: ['/gongyi/list3'],
          isShow: false
        },
        {
          name: '设备列表',
          path: '/production/she-bei/list',
          control: ['/sheBei/list'],
          isShow: false
        },
        {
          name: '加工商列表',
          path: '/production/processor/list',
          control: ['/processor/saveOrUpdate'],
          isShow: false
        }
      ]
    },
    {
      name: '库存管理',
      path: '/new/stock',
      control: [],
      isShow: false,
      children: [
        {
          name: '库存列表',
          path: '/new/stock/inventory/list',
          control: ['/inventory/stocklist'],
          isShow: false
        },
        {
          name: '入库单列表',
          path: '/new/stock/stockIn/list',
          control: ['/stockIn/list'],
          isShow: false
        },
        {
          name: '出库单列表',
          path: '/new/stock/stockOut/list',
          control: ['/stockOut/list'],
          isShow: false
        },
        {
          name: '盘点单列表',
          path: '/new/stock/stockCheck/list',
          control: ['/stockCheck/list'],
          isShow: false
        },
        {
          name: '调拨单列表',
          path: '/new/stock/stockTransfer/list',
          control: ['/stockTransfer/list'],
          isShow: false
        },
        {
          name: '收发存汇总',
          path: '/new/stock/inventory/sfc',
          control: ['/inventory/sfcList'],
          isShow: false
        },
        {
          name: '仓库列表',
          path: '/new/stock/warehouse/list',
          control: ['/newWarehouse/list'],
          isShow: false
        },
        {
          name: '仓位列表',
          path: '/new/stock/location/list',
          control: ['/warehouseLocation/list'],
          isShow: false
        },
        {
          name: '仓库平面图',
          path: '/new/stock/layout',
          control: ['/warehouseLocation/list'],
          isShow: false
        }
      ]
    },
    {
      name: '商品管理',
      path: '/goods',
      control: [],
      isShow: false,
      children: [
        {
          name: '商品列表',
          path: '/goods/system/shang-pin',
          control: ['/products/saveOrUpdate'],
          isShow: false
        },
        {
          name: '模板列表',
          path: '/goods/system/mu-ban',
          control: ['/muBan/saveOrUpdate'],
          isShow: false
        },
        {
          name: '类目管理',
          path: '/goods/category/manage',
          control: ['/columnData/saveOrUpdate'],
          isShow: false
        },
        {
          name: '字段管理',
          path: '/goods/system/zi-duan',
          control: ['/ziDuanKu/saveOrUpdate'],
          isShow: false
        }
      ]
    },
    {
      name: '财务管理',
      path: '/finance',
      control: [],
      isShow: false,
      children: [
        {
          name: '应收列表',
          path: '/finance/payin/list',
          control: ['/reportBill/billCashById'],
          isShow: false
        },
        {
          name: '应付列表',
          path: '/finance/payout/list',
          control: ['/caiGouFuKuan/saveOrUpdate'],
          isShow: false
        },
        {
          name: '银行账户列表',
          path: '/finance/bank/list',
          control: ['/bank/saveOrUpdate'],
          isShow: false
        }
      ]
    },
    {
      name: '企业管理',
      path: '/company',
      control: [],
      isShow: false,
      children: [
        {
          name: '组织架构',
          path: '/company/jiagou/department',
          control: ['/columnData/saveOrUpdate', '/column/saveOrUpdate'],
          isShow: false
        },
        {
          name: '工作地点',
          path: '/company/jiagou/location',
          control: ['/work2/saveOrUpdate'],
          isShow: false
        },
        {
          name: '职位管理',
          path: '/company/gangwei/role',
          control: ['/gangwei2/saveOrUpdate'],
          isShow: false
        },
        {
          name: '员工管理',
          path: '/company/yuangong/huamingce',
          control: ['/huaMingCe2/saveOrUpdate'],
          isShow: false
        },
        {
          name: '档案管理',
          path: '/company/dangan',
          control: ['/huaMingCe2/saveOrUpdate'],
          isShow: false
        }
      ]
    },
    {
      name: '基础设置',
      path: '/base',
      control: [],
      isShow: false,
      children: [
        {
          name: '类别管理',
          path: '/base/category/list',
          control: ['/categorySetting/updateVue', '/categorySetting/saveVue'],
          isShow: false
        },
        {
          name: '参数管理',
          path: '/base/dict/list',
          control: ['/dict/saveOrUpdateDict'],
          isShow: false
        },
        {
          name: '计量单位',
          path: '/base/unit/list',
          control: ['/unitSetting/saveVue', '/unitSetting/updateVue'],
          isShow: false
        },
        {
          name: '地址管理',
          path: '/base/address/list',
          control: ['/address/saveOrUpdate'],
          isShow: false
        },
        {
          name: '印章管理',
          path: '/base/seal/list',
          control: ['/yinZhang/saveOrUpdate'],
          isShow: false
        }
      ]
    },
    {
      name: '系统设置',
      path: '/system',
      control: [],
      isShow: false,
      children: [
        {
          name: '员工管理',
          path: '/system/account/list',
          control: ['/account/getAccountList'],
          isShow: false
        },
        {
          name: '岗位列表',
          path: '/system/role/list',
          control: ['/role/editVue'],
          isShow: false
        },
        {
          name: '权限列表',
          path: '/system/power/list',
          control: ['/role/assignPermissionSwitchListVue', '/role/assignPermissionSwitchVue'],
          isShow: false
        },
        {
          name: '权限配置',
          path: '/system/power/config',
          control: ['/role/assignPermissionSwitchListVue', '/role/assignPermissionSwitchVue'],
          isShow: false
        },
        {
          name: '操作日志',
          path: '/system/logger/list',
          control: ['/logger/getList'],
          isShow: false
        }
      ]
    }
  ]
}

export default constantNavList
